import React from "react";

const Section = ({ title, subtitle, children }) => {
  return (
    <section className="space-y-3">
      {(title || subtitle) && (
        <div>
          {title && <h2 className="text-lg font-semibold text-slate-900">{title}</h2>}
          {subtitle && <p className="text-sm text-slate-600">{subtitle}</p>}
        </div>
      )}
      {children}
    </section>
  );
};

export default Section;
